import { createAction } from 'redux-actions-helpers'
import { ModuleType } from '../AdminLessonEditPage/types'

export const fetchThemes = createAction(
  '@@admin-create-lesson/FETCH_THEMES',
  (courseId: string): any => ({ courseId })
)

export const fetchThemesSuccess = createAction(
  '@@admin-create-lesson/FETCH_THEMES_SUCCESS',
  (result: string): any => ({ result })
)

export const fetchThemesFailure = createAction(
  '@@admin-create-lesson/FETCH_THEMES_FAILURE',
  (error: string): any => ({ error })
)

export const fetchModules = createAction(
  '@@admin-create-lesson/FETCH_MODULES',
  (id: string): any => ({ id })
)

export const fetchModulesSuccess = createAction(
  '@@admin-create-lesson/FETCH_MODULES_SUCCESS',
  (result: ModuleType[]): any => ({ result })
)

export const fetchModulesFailure = createAction(
  '@@admin-create-lesson/FETCH_MODULES_FAILURE',
  (error: string): any => ({ error })
)

export const createLesson = createAction(
  '@@admin-create-lesson/CREATE_LESSON',
  (
    id: string,
    mid: string,
    title: string,
    icon: File,
    theme: string,
    assistantCaption: string,
    indexNumber: number,
    timeToStudy: number,
    isFirst: string,
    isLast: string,
    isFree: string,
    availableAt: string,
    position: number
  ): any => ({
    id,
    mid,
    title,
    icon,
    theme,
    assistantCaption,
    indexNumber,
    timeToStudy,
    isFirst,
    isLast,
    isFree,
    availableAt,
    position,
  })
)

export const createLessonSuccess = createAction(
  '@@admin-create-lesson/CREATE_LESSON_SUCCESS'
)

export const createLessonFailure = createAction(
  '@@admin-create-lesson/CREATE_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const connectModuleLesson = createAction(
  '@@admin-create-lesson/CONNECT_MODULE_LESSON',
  (
    mid: string,
    lid: string,
    indexNumber: number,
    timeToStudy: number,
    assistantCaption: string,
    isFirst: string,
    isLast: string,
    isFree: string,
    availableAt: string,
    position: number
  ): any => ({
    mid,
    lid,
    indexNumber,
    timeToStudy,
    assistantCaption,
    isFirst,
    isLast,
    isFree,
    availableAt,
    position,
  })
)

export const connectModuleLessonSuccess = createAction(
  '@@admin-create-lesson/CONNECT_MODULE_LESSON_SUCCESS'
)

export const connectModuleLessonFailure = createAction(
  '@@admin-create-lesson/CONNECT_MODULE_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-create-lesson/DESTROY')
